import React, { FC, useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ConditionalLink } from 'components/ConditionalLink';
import ListingContext from '../../../../providers/Listing/Listing.context';
import { BUTTON_CLASSES } from '../MarketYourDeal/MarketYourDeal.component';
import AddContactsImage from 'assets/images/contact.webp';
import AddressBookIcon from 'icons/AddressBook.icon';
import { CONTACTS_ROUTE } from 'data/global';

import './AddContactsToDeal.styles.scss';

type AddContactsToDealProps = { className?: string };

const AddContactsToDeal: FC<AddContactsToDealProps> = ({ className }) => {
  const { areActionsDisabled } = useContext(ListingContext);

  const classes = classNames(
    'add-contacts-to-deal',
    { disabled: areActionsDisabled },
    className,
  );

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnClick = useCallback(() => {
    if (areActionsDisabled) return;
    navigate(CONTACTS_ROUTE);
  }, [areActionsDisabled, navigate]);

  return (
    <div className={classes} onClick={handleOnClick}>
      <div className="card-heading">
        <p>{t('addYourContactsToThisDeal')}</p>
        <p>{t('manageYourOwnPrivateAddressBook')}</p>
      </div>

      <div className="images-wrapper">
        <img alt="Add contacts to this deal" src={AddContactsImage} />
        <img alt="Add contacts to this deal" src={AddContactsImage} />
        <img alt="Add contacts to this deal" src={AddContactsImage} />
      </div>

      <ConditionalLink
        isDisabled={areActionsDisabled}
        disabledClassName={BUTTON_CLASSES}
        linkClassName={BUTTON_CLASSES}
        to={CONTACTS_ROUTE}
      >
        {t('manageContacts')}
        <AddressBookIcon />
      </ConditionalLink>
    </div>
  );
};

export default AddContactsToDeal;
